export default {
  /**
   * 获取菜单列表
   */
  getMenuList: '/ar-textbook/admin/menu/list',
  /**
   * 添加，编辑 菜单
   */
  editMenu: '/ar-textbook/admin/menu/addOrUpdateMenu',
  /**
   *  添加，编辑 按钮
   */
  editButton: '/ar-textbook/admin/menu/addOrUpdateButton',
  /**
   *  删除菜单，按钮
   */
  deleteMenu: '/ar-textbook/admin/menu/deleteMenu',
}
